/* globals LearningStandard */

// eslint-disable-next-line no-unused-vars
function Package (Id, ObjectivesGlobalToSystem, LearningStandardValue, Properties, SharedDataGlobalToSystem, LearningObjects) {
    this.Id = Id;
    this.ObjectivesGlobalToSystem = ObjectivesGlobalToSystem;
    this.LearningStandard = new LearningStandard(LearningStandardValue);
    this.Properties = Properties;
    this.SharedDataGlobalToSystem = SharedDataGlobalToSystem;
    this.LearningObjects = LearningObjects;
}
